module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cargue-ips/cargue-ips.component.css
// module id = ./src/app/cargue-ips/cargue-ips.component.css
// module chunks = main